var file_upload_viewer_default = {
  "fontElementMap": "_0Wt6l",
  "file_upload_container": "akifz",
  "file_upload_link": "uOief",
  "file_upload_error_container": "SASpD",
  "file_upload_file_info": "VbzNp",
  "file_upload_type_icon": "_42l24",
  "file_upload_status_icon_container": "PoJAA",
  "file_upload_status_icon": "UWP4-",
  "file_upload_description": "YdqSL",
  "file_upload_name_container": "_5j6Ip",
  "file_upload_name": "FNLct",
  "file_upload_extension": "y6RVy",
  "file_loader_icon": "-BBqs",
  "file_upload_icon_frame": "EPjj4",
  "file_upload_icon_background": "_10DiK"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
